import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { RoleplayApiService } from '../../service/roleplay.service';

import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { ToastrService } from 'ngx-toastr';
import { TraineeListService } from '../../service/trainee-list.service';
import { RoleplayCardInfo } from '../../model/rolePlay';
import { InteractionService } from '../../service/interaction/interaction.service';

import { ConstantConfig } from '../../utility/constant-config';

@Component({
    selector: 'app-trainee-dasboard',
    templateUrl: './trainee-dasboard.component.html',
    styleUrl: './trainee-dasboard.component.scss',
    standalone: false
})
export class TraineeDasboardComponent implements OnInit {
  items: any[];
  config: any = ConstantConfig;
  test_version: boolean = true;
  totalTrainerCount: number = 0;
  userId: number = 0;
  showChildDiv = false;
  role: string = '';
  filteredItems: any[] = [];
  filterValue: any;
  menuForTrainer: boolean = false;
  subscription: Subscription;
  completeCount: number = 0;
  totalCount: number = 0;
  sessionType: string = 'SCORE'; // SCORE, PRACTICE
  showNoCardsMessage: boolean;
  drName:string;
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
  constructor(private http: HttpClient, private rolePlayService: RoleplayApiService, public router: Router, 
    private TraineeList: TraineeListService, private dialog: MatDialog, private toastr: ToastrService, private intrService: InteractionService) { }

  ngOnInit(): void {
    this.rolePlayService.intializeAPIUrl();

    this.userId = Number(sessionStorage.getItem('userId'));
    this.role = sessionStorage.getItem('role');
    if(this.role) {
      if(this.role === 'TRAINER' || this.role === 'SUPERVISOR') {
        this.intrService.refreshHistoryHandler({refreshMenu: 'role-play', id: 0, subType: "", dashRolePlay: "dashRolePlay"});
        this.loadData(this.userId);
        this.menuForTrainer = true;
      } else {
        this.intrService.refreshHistoryHandler({refreshMenu: 'role-play', id: 0, subType: "", dashRolePlay: "dashRolePlay"});
        this.getAssignScenarioToTrainee(this.userId);
      }
     } else {
      this.getAssignScenarioToTrainee(this.userId);
     }
  }
  applyFilter(value: string) {
    const filterValue = value.toLowerCase().trim();
    this.filteredItems = this.items.filter(item =>
      (item.scenario_name && item.scenario_name.toLowerCase().includes(filterValue)) ||
      (item.objectives && item.objectives[0] && item.objectives[0].toLowerCase().includes(filterValue)) ||
      (item.desc && item.desc.toLowerCase().includes(filterValue))
    );

    // Check if no matches found
    if (this.filteredItems.length === 0) {
      // Set flag to indicate no cards should be displayed
      this.showNoCardsMessage = true;
    } else {
      // Set flag to indicate cards should be displayed
      this.showNoCardsMessage = false;
    }
  }
  toggleChildDiv() {
    this.rolePlayService.setVisibility(true);
  }
  loadData(loginId: number): void {
    this.subscription = this.TraineeList.getScenarioToTrainer(this.business_unit_code).subscribe({
      next: (response) => {
        if(response.length > 0) {
          this.totalTrainerCount = response.length;
          this.items = response.map((item)=> {
            const foundElements = item.meta_data.filter(element => element['roleplay_metadata_type'] === 'objectives');
            item.objectives = foundElements.map(element => element['roleplay_metadata_val']);
          });
        }
        this.items = response;
      },
      error: (error) => {
        console.error('Error fetching objectives data', error);
      }
    });
  }
  getAssignScenarioToTrainee(loginId: number) {
    this.TraineeList.getScenarioToTrainee(loginId, this.business_unit_code).subscribe(data => {
      this.items = data;
      this.drName=data.dr_name;
      this.items.sort((a, b) => {
        if (a.roleplay_status === "New" && b.roleplay_status !== "New") {
            return -1;
        }
        if (a.roleplay_status !== "New" && b.roleplay_status === "New") {
            return 1;
        }
        return 0;
    });
      this.totalCount = this.items.length;
      this.completeCount = this.items.filter(item => item.roleplay_status === 'Completed').length;
    });
  }
  delete(scenarioId: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
      data: {message: 'Are you sure you want to delete?'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.TraineeList.deleteAssignScenario(scenarioId).subscribe(data => {
          const message = data.status;
          if (message == "deleted successfully") {
            this.toastr.success('Deleted Successfully.', '', { positionClass: 'toast-top-right' });
          } else {
            this.toastr.info(message, '', { positionClass: 'toast-top-right' });
          }
          this.loadData(this.userId);
        });
      }
    });
  }
 
  toggleSwitchColor(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    target.classList.toggle('active');
  }
  cardClickHandler(item: RoleplayCardInfo) {
    item.session_type = this.sessionType;
     this.rolePlayService.setVisibility(true);
    this.rolePlayService.setRoleplayInfoSidebar(item);
    this.router.navigate([`app-assigned-roleplay/${item.scenario_id}`], { 
      queryParams: { dr_name: item.doctor_name },
      skipLocationChange: true 
    });
  }
  doctorprofile(){
    this.router.navigate(['/app-doctor-profile'], { skipLocationChange: true});
  }
  quiz() {
    this.test_version = true;
  }
  
  roleplay() {
    this.test_version = false;
  }
  score() {
    this.test_version = true;
    this.sessionType = 'SCORE';
    this.toastr.success('You switched to Score Track', 'Score Track');
  }
  practice() {
    this.test_version = false;
    this.sessionType = 'PRACTICE';
    this.toastr.success('You switched to Practice Track', 'Practice Track');
  }
  createScenario() {
    this.router.navigate(['/app-roleplay-container'], { skipLocationChange: true });
  }
  updateScenario(id) {
    this.router.navigate([`/app-roleplay-container/${id}`], { skipLocationChange: true });
  }
  redirectToAssignRoleplay(scenarioId: number): void {
    this.router.navigate(['/app-roleplay-assign'], { skipLocationChange: true, queryParams: { id: scenarioId } });
  }
}